/**
 * Overview Cards Component
 * Displays KPI cards for support ticket overview
 */

import React from 'react';
import { Ticket, CheckCircle, Clock, TrendingUp } from 'lucide-react';

export default function OverviewCards({ overview }) {
  if (!overview) {return null;}

  const cards = [
    {
      title: 'Total Tickets',
      value: overview.total_tickets || 0,
      icon: Ticket,
      color: 'blue',
    },
    {
      title: 'Resolved',
      value: overview.resolved_tickets || 0,
      subtitle: `${Math.round((overview.resolved_tickets / overview.total_tickets) * 100) || 0}% resolution rate`,
      icon: CheckCircle,
      color: 'green',
    },
    {
      title: 'Avg Resolution Time',
      value: `${Math.round(overview.avg_resolution_minutes / 60) || 0}h`,
      subtitle: 'Hours to resolve',
      icon: Clock,
      color: 'orange',
    },
    {
      title: 'SLA Compliance',
      value: `${overview.first_response_sla_compliance_pct || 0}%`,
      subtitle: 'First response met',
      icon: TrendingUp,
      color: 'purple',
    },
  ];

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    orange: 'bg-orange-50 text-orange-600',
    purple: 'bg-purple-50 text-purple-600',
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{card.title}</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{card.value}</p>
                {card.subtitle && (
                  <p className="text-xs text-gray-500 mt-1">{card.subtitle}</p>
                )}
              </div>
              <div className={`p-3 rounded-lg ${colorClasses[card.color]}`}>
                <Icon className="w-5 h-5" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
